module.exports = __webpack_public_path__ + "static/media/AdaBotFromRight.e2b8ff96.png";